// extracted by mini-css-extract-plugin
export var numpadContainer = "_ow-1";
export var phoneButton = "_ow-0";